import { render, staticRenderFns } from "./ArticleHabit.vue?vue&type=template&id=7cfca4f7&scoped=true"
import script from "./ArticleHabit.vue?vue&type=script&lang=js"
export * from "./ArticleHabit.vue?vue&type=script&lang=js"
import style0 from "./ArticleHabit.vue?vue&type=style&index=0&id=7cfca4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfca4f7",
  null
  
)

export default component.exports